import { createLocalOrUTC } from './from-anything';

export function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/create/utc.js
// module id = 203
// module chunks = 3